var $ = require('jquery');

module.exports = {
	init: function() {

		var $container = $('.tabs');
		var $heading = $('.tabHeading');
		var $content = $('.tab');
		var $text = $('.tab__text');
		var activeClass = {
			heading: 'tabHeading--active',
			content: 'tab--active',
			any: '[class$=--active]'
		};

		// Do nothing if specified container absent
		if ($container.length === 0) {
			return;
		}

		/**
		 * Activates the tab specified
		 * @param  {number} specifiedTab The index of the tab to be activated
		 */
		function activateTab(specifiedTab, event) {
			// Deactivate existing active tabs
			$(activeClass.any, $container).removeClass(activeClass.heading + ' ' + activeClass.content);
			
			// Trigger GA event
			// $(event.target).trigger('analyticsEvent');

			// Activate tab heading based on passed index
			$heading.filter(function(index) {
						return index == specifiedTab;
					})
					.addClass(activeClass.heading);

			// Activate tab content based on passed index
			$content.filter(function(index) {
						return index == specifiedTab;
					})
					.addClass(activeClass.content);
		}

		$heading.on('click.tabClick', function(event) {
			event.preventDefault();

			// Do nothing if already selected
			if ($(this).hasClass(activeClass.heading)) {
				return;
			}

			activateTab($(this).index(), event);
		});

		// Deactivate .tab__text links to tabs, pass intended target to activateTab()
		$('a[href*="tab"]', $text).on('click.textAnchor', function(event) {
			event.preventDefault();
			var specified = parseInt($(this).attr('href').slice(-1)) - 1;

			activateTab(specified);
		});
	}
};
